function selectProduct(allVariants, currentVariant, newValue, optionsIndex) {
  for (const variant of allVariants) {
    let isMatch = true;
    for (var i = 0; i < variant.options.length; i++) {
      const variantOption = variant.options[i];
      const selectedVariantOption = currentVariant.options[i];
      if (i === optionsIndex && variantOption !== newValue) {
        isMatch = false;
        break;
      } else if (
        i !== optionsIndex &&
        variantOption !== selectedVariantOption
      ) {
        isMatch = false;
        break;
      }
    }

    if (isMatch) {
      loadProductFromVariantId(variant.id);
      return;
    }
  }
}

function loadProductFromVariantId(variantId) {
  const url = new URL(window.location.href);
  url.searchParams.set("variant", variantId);
  window.history.pushState(null, "", url.toString());
  window.location.reload();
}

function assignAddProductToCartSubmitHandler(formId) {
  document.getElementById(formId).addEventListener("submit", function (event) {
    event.preventDefault();

    const formData = new FormData(event.target);
    const config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(Object.fromEntries(formData)),
    };

    fetch(window.Shopify.routes.root + "cart/add.js", config)
      .then((response) => response.json())
      .then((data) => {
        reloadAllCartCounts();
        openAddedToCartModal(data);
      })
      .catch((error) => {});
  });
}

function isProductPreorder(productVariant, productOptions, preorderColors) {
  if (preorderColors == undefined || preorderColors.length === 0) {
    return false;
  }
  /** check colour for preorder */
  let colorIndex = -1;
  for (var i = 0; i < productOptions.length; i++) {
    if (productOptions[i].name.toLowerCase() === "colour") {
      colorIndex = i;
      break;
    }
  }

  if (colorIndex === -1) {
    return false;
  }

  const colorOption = productVariant.options[colorIndex]
    ?.toLowerCase()
    ?.replaceAll(" ", "");
  return (
    colorOption !== undefined &&
    preorderColors.includes(colorOption.toLowerCase())
  );
}
